<template>
  <div>
    <h1 v-if="showTitleOfGroupLayer" class="group-layer-title white--text mb-6">{{group.name}}</h1>

    <div v-if="group.type === 'satellite_grouping_player'">
      <left-satellite-sublayer
        :group="group"
        :locations="locations"
        :satellites="satellites"
        :initialOpacity="100"
        :timeFeatures="satelliteTimeFeatures"
        @changeInputMenu="changeInputMenu($event)"
        @changeCurrentSatelliteState="changeCurrentSatelliteState($event)"
      ></left-satellite-sublayer>
    </div>

    <div v-else>
      <div v-show="enabledGroupLayer" :class="`sub-layers group-layers-${group.name}`" v-for="(item,i) in group.layers" :key="i">
        <left-sub-layer-map-menu
          v-if="!item.values_.hide_on_menu"
          :layer="item"
          @changeInputMenu="changeInputMenu($event)"
          @changeLayersPesticides="changeInputMenu($event)"
          @changeLayersErosion="changeInputMenu($event)"
          @changeLayersDiffuse="changeInputMenu($event)"
          @changeLayersRestrictions="changeInputMenu($event)"
          />
      </div>
    </div>

  </div>
</template>

<script>
import LeftSubLayerMapMenu from "@/components/common/NewMapMenu/LeftSubLayerMapMenu";
import LeftSatelliteSublayer from "@/components/common/NewMapMenu/SatelliteSublayer/LeftSatelliteSublayer";
export default {
  name: "LeftGroupLayerMapMenu",
  props:['group', 'locations', 'satellites'],
  components:{
    LeftSatelliteSublayer,
    LeftSubLayerMapMenu,
  },
  data:()=>({
    enabledGroupLayer: undefined,
    satelliteTimeFeatures: undefined,
  }),
  created(){
    this.enabledGroupLayer = true;
  },
  computed:{
    showTitleOfGroupLayer(){
      return this.group && this.group.type !== 'overlayers' && this.group.type !== 'satellite_grouping_player';
    },
  },
  methods:{
    changeEnabledGroupLayer(visible){
      this.$emit('changeEnabledGroupLayer', {visible, name: this.group.name})
    },
    changeInputMenu(event){
      this.$emit(event.eventName, event.params)
    },
    changeCurrentSatelliteState(state){
      const lastVisibleLayer = this.group.layers.find((layer) => layer.values_.visible === true);
      const currentVisibleLayer = this.group.layers.find((layer) => layer.values_.name === `${state.location} - ${state.satellite}`);
      const currentVisibleLayerId = currentVisibleLayer?.values_.id;
      const lastVisibleLayerId = lastVisibleLayer?.values_.id;
      let bbox = undefined;
      if(currentVisibleLayerId !== lastVisibleLayerId){
        bbox = currentVisibleLayer?.values_.url_params.BBOX;
      }
      this.satelliteTimeFeatures = currentVisibleLayer?.values_.timeFeatures;
      this.$emit('changeCurrentSatelliteState', { lastVisibleLayerId, currentVisibleLayerId, bbox, ...state});
    }
  }
}
</script>
<style scoped>
  .group-layer-title{
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    margin: 24px 0px;
  }

  .layer-title{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
  }
</style>
